import isAxiosResponseError from "./isAxiosResponseError";
import { isAsosAuthTimeoutError } from "../identity";

const isServiceError = e =>
  isAxiosResponseError(e) || isAsosAuthTimeoutError(e);

export default isServiceError;
